<template>
    <Modal class="tiw__step__chooseSigningType">
        <template #header>
            <p class="tiw__step__chooseSigningType__header tiw__h2">
                <AwardIcon />
                {{ useTranslate("tiw__chooseSigningType__title") }}
            </p>

            <div class="tiw__step__chooseSigningType__text">
                {{ useTranslate("tiw__chooseSigningType__text") }}
            </div>
        </template>

        <div class="tiw__step__chooseSigningType__body">
            <div
                class="tiw__rate-chooser tiw__step__chooseSigningType__chooser"
                :class="{ 'tiw__rate-chooser_loading': loadingToNext }"
            >
                <div
                    v-if="showTrustmeKz"
                    class="tiw__rate-chooser__element"
                    @click="onClickSigningType('TRUSTME_KZ')"
                >
                    <label class="tiw__rate-chooser__item">
                        <!--
                        <svg class="tiw__rate-chooser__figure" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="64" height="64" fill="white" />
                            <path d="M48 55C48 57.209 46.209 59 44 59H20C17.791 59 16 57.209 16 55V9C16 6.791 17.791 5 20 5H44C46.209 5 48 6.791 48 9V55Z" stroke="#768798" stroke-width="2.4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M38 5V7C38 8.10457 37.1046 9 36 9H28C26.8954 9 26 8.10457 26 7V5" stroke="#768798" stroke-width="2.4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M37 54L27 54" stroke="#768798" stroke-width="2.4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M25.3333 30.4091L27.5556 32.6818M27.5556 30.4091L25.3333 32.6818M30.8889 30.4091L33.1111 32.6818M33.1111 30.4091L30.8889 32.6818M36.4444 30.4091L38.6667 32.6818M38.6667 30.4091L36.4444 32.6818M37.5556 27H26.4444C24.3489 27 23.3022 27 22.6511 27.6659C22 28.3318 22 29.4023 22 31.5455C22 33.6886 22 34.7591 22.6511 35.425C23.3022 36.0909 24.3489 36.0909 26.4444 36.0909H37.5556C39.6511 36.0909 40.6978 36.0909 41.3489 35.425C42 34.7591 42 33.6886 42 31.5455C42 29.4023 42 28.3318 41.3489 27.6659C40.6978 27 39.6511 27 37.5556 27Z" :stroke="mainColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        -->
                        <svg
                            class="tiw__rate-chooser__figure"
                            width="72"
                            height="72"
                            viewBox="0 0 72 72"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clip-path="url(#clip0_31098_9561)">
                                <path d="M72 0H0V72H72V0Z" fill="white" />
                                <path
                                    d="M42.75 5.625V8.125C42.75 9.22957 41.8546 10.125 40.75 10.125H31.25C30.1454 10.125 29.25 9.22957 29.25 8.125V5.625M41.625 60.75H30.375M54 61.875C54 64.3601 51.9851 66.375 49.5 66.375H22.5C20.0149 66.375 18 64.3601 18 61.875V10.125C18 7.63987 20.0149 5.625 22.5 5.625H49.5C51.9851 5.625 54 7.63987 54 10.125V61.875Z"
                                    stroke="#768798"
                                    stroke-width="2.4"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M28 34.1538L30.6667 36.9231M30.6667 34.1538L28 36.9231M34.6667 34.1538L37.3333 36.9231M37.3333 34.1538L34.6667 36.9231M41.3333 34.1538L44 36.9231M44 34.1538L41.3333 36.9231M42.6667 30H29.3333C26.8187 30 25.5627 30 24.7813 30.8114C24 31.6228 24 32.9271 24 35.5385C24 38.1498 24 39.4542 24.7813 40.2655C25.5627 41.0769 26.8187 41.0769 29.3333 41.0769H42.6667C45.1813 41.0769 46.4373 41.0769 47.2187 40.2655C48 39.4542 48 38.1498 48 35.5385C48 32.9271 48 31.6228 47.2187 30.8114C46.4373 30 45.1813 30 42.6667 30Z"
                                    stroke="#3F4E5D"
                                    stroke-width="1.8"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_31098_9561">
                                    <rect width="72" height="72" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        <div class="tiw__rate-chooser__body">
                            <p class="tiw__rate-chooser__title">
                                {{
                                    useTranslate(
                                        "tiw__chooseSigningType__signingType__trustmeKz__title",
                                    )
                                }}
                            </p>
                            <p class="tiw__rate-chooser__text">
                                {{
                                    useTranslate(
                                        "tiw__chooseSigningType__signingType__trustmeKz__description",
                                    )
                                }}
                            </p>
                        </div>
                    </label>
                </div>
                <div
                    v-if="showScrive"
                    class="tiw__rate-chooser__element"
                    @click="onClickSigningType('SCRIVE')"
                >
                    <label class="tiw__rate-chooser__item">
                        <!--
                        <svg class="tiw__rate-chooser__figure" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="64" height="64" fill="white" />
                            <path d="M48 55C48 57.209 46.209 59 44 59H20C17.791 59 16 57.209 16 55V9C16 6.791 17.791 5 20 5H44C46.209 5 48 6.791 48 9V55Z" stroke="#768798" stroke-width="2.4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M38 5V7C38 8.10457 37.1046 9 36 9H28C26.8954 9 26 8.10457 26 7V5" stroke="#768798" stroke-width="2.4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M37 54L27 54" stroke="#768798" stroke-width="2.4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M25.3333 30.4091L27.5556 32.6818M27.5556 30.4091L25.3333 32.6818M30.8889 30.4091L33.1111 32.6818M33.1111 30.4091L30.8889 32.6818M36.4444 30.4091L38.6667 32.6818M38.6667 30.4091L36.4444 32.6818M37.5556 27H26.4444C24.3489 27 23.3022 27 22.6511 27.6659C22 28.3318 22 29.4023 22 31.5455C22 33.6886 22 34.7591 22.6511 35.425C23.3022 36.0909 24.3489 36.0909 26.4444 36.0909H37.5556C39.6511 36.0909 40.6978 36.0909 41.3489 35.425C42 34.7591 42 33.6886 42 31.5455C42 29.4023 42 28.3318 41.3489 27.6659C40.6978 27 39.6511 27 37.5556 27Z" :stroke="mainColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        -->
                        <svg
                            class="tiw__rate-chooser__figure"
                            width="72"
                            height="72"
                            viewBox="0 0 72 72"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clip-path="url(#clip0_31098_9561)">
                                <path d="M72 0H0V72H72V0Z" fill="white" />
                                <path
                                    d="M42.75 5.625V8.125C42.75 9.22957 41.8546 10.125 40.75 10.125H31.25C30.1454 10.125 29.25 9.22957 29.25 8.125V5.625M41.625 60.75H30.375M54 61.875C54 64.3601 51.9851 66.375 49.5 66.375H22.5C20.0149 66.375 18 64.3601 18 61.875V10.125C18 7.63987 20.0149 5.625 22.5 5.625H49.5C51.9851 5.625 54 7.63987 54 10.125V61.875Z"
                                    stroke="#768798"
                                    stroke-width="2.4"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M28 34.1538L30.6667 36.9231M30.6667 34.1538L28 36.9231M34.6667 34.1538L37.3333 36.9231M37.3333 34.1538L34.6667 36.9231M41.3333 34.1538L44 36.9231M44 34.1538L41.3333 36.9231M42.6667 30H29.3333C26.8187 30 25.5627 30 24.7813 30.8114C24 31.6228 24 32.9271 24 35.5385C24 38.1498 24 39.4542 24.7813 40.2655C25.5627 41.0769 26.8187 41.0769 29.3333 41.0769H42.6667C45.1813 41.0769 46.4373 41.0769 47.2187 40.2655C48 39.4542 48 38.1498 48 35.5385C48 32.9271 48 31.6228 47.2187 30.8114C46.4373 30 45.1813 30 42.6667 30Z"
                                    stroke="#3F4E5D"
                                    stroke-width="1.8"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_31098_9561">
                                    <rect width="72" height="72" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        <div class="tiw__rate-chooser__body">
                            <p class="tiw__rate-chooser__title">
                                {{
                                    useTranslate(
                                        "tiw__chooseSigningType__signingType__trustmeKz__title",
                                    )
                                }}
                            </p>
                            <p class="tiw__rate-chooser__text">
                                {{
                                    useTranslate(
                                        "tiw__chooseSigningType__signingType__trustmeKz__description",
                                    )
                                }}
                            </p>
                        </div>
                    </label>
                </div>
                <div
                    v-if="showWithoutSms"
                    class="tiw__rate-chooser__element"
                    @click="onClickSigningType('WITHOUT_SMS')"
                >
                    <label class="tiw__rate-chooser__item">
                        <!--
                        <svg class="tiw__rate-chooser__figure" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="64" height="64" fill="white" />
                            <path d="M48 55C48 57.209 46.209 59 44 59H20C17.791 59 16 57.209 16 55V9C16 6.791 17.791 5 20 5H44C46.209 5 48 6.791 48 9V55Z" stroke="#768798" stroke-width="2.4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M38 5V7C38 8.10457 37.1046 9 36 9H28C26.8954 9 26 8.10457 26 7V5" stroke="#768798" stroke-width="2.4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M37 54L27 54" stroke="#768798" stroke-width="2.4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M35.214 25.9815L36.616 24.5805C36.9877 24.2088 37.4918 24 38.0175 24C38.5432 24 39.0473 24.2088 39.419 24.5805C39.7907 24.9522 39.9995 25.4564 39.9995 25.982C39.9995 26.5077 39.7907 27.0118 39.419 27.3835L38.018 28.7855M35.214 25.9815L26.98 34.2155C25.935 35.2615 25.412 35.7835 25.056 36.4205C24.7 37.0575 24.342 38.5605 24 39.9995C25.438 39.6575 26.942 39.2995 27.579 38.9435C28.216 38.5875 28.739 38.0645 29.784 37.0195L38.018 28.7855M35.214 25.9815L38.018 28.7855M31 39.9995H37" :stroke="mainColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        -->
                        <svg
                            class="tiw__rate-chooser__figure"
                            width="72"
                            height="72"
                            viewBox="0 0 72 72"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clip-path="url(#clip0_31098_9549)">
                                <path d="M72 0H0V72H72V0Z" fill="white" />
                                <path
                                    d="M42.75 5.625V8.125C42.75 9.22957 41.8546 10.125 40.75 10.125H31.25C30.1454 10.125 29.25 9.22957 29.25 8.125V5.625M41.625 60.75H30.375M54 61.875C54 64.3601 51.9851 66.375 49.5 66.375H22.5C20.0149 66.375 18 64.3601 18 61.875V10.125C18 7.63987 20.0149 5.625 22.5 5.625H49.5C51.9851 5.625 54 7.63987 54 10.125V61.875Z"
                                    stroke="#768798"
                                    stroke-width="2.4"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M39.6161 29.2293L41.1934 27.6531C41.6116 27.2349 42.1788 27 42.7702 27C43.3616 27 43.9287 27.2349 44.3469 27.6531C44.7651 28.0713 45 28.6384 45 29.2298C45 29.8212 44.7651 30.3884 44.3469 30.8066L42.7707 32.3839M39.6161 29.2293L30.3526 38.4928C29.1769 39.6696 28.5885 40.2569 28.188 40.9735C27.7875 41.6902 27.3848 43.3811 27 45C28.6178 44.6152 30.3098 44.2125 31.0265 43.812C31.7431 43.4115 32.3315 42.8231 33.5072 41.6474L42.7707 32.3839M39.6161 29.2293L42.7707 32.3839M34.8752 45H41.6254"
                                    stroke="#3F4E5D"
                                    stroke-width="1.8"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_31098_9549">
                                    <rect width="72" height="72" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>

                        <div class="tiw__rate-chooser__body">
                            <p class="tiw__rate-chooser__title">
                                {{
                                    useTranslate(
                                        "tiw__chooseSigningType__signingType__withoutSms__title",
                                    )
                                }}
                            </p>
                            <p class="tiw__rate-chooser__text">
                                {{
                                    useTranslate(
                                        "tiw__chooseSigningType__signingType__withoutSms__description",
                                    )
                                }}
                            </p>
                        </div>
                    </label>
                </div>
            </div>
            <div class="tiw_group tiw_group-sb">
                <Button
                    type="button"
                    variant="skeleton"
                    class="tiw__step__chooseSigningType__btn-back"
                    :disabled="loadingToNext"
                    @click="onClickBack"
                >
                    <ArrowIcon />
                    <span>{{ useTranslate("tiw__back") }}</span>
                </Button>
            </div>
        </div>
    </Modal>
</template>

<script lang="ts">
export default {
    name: "ChooseSigningType",
};
</script>

<script setup lang="ts">
/**
 * * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [ChooseSigningType]
 */

// Hooks
import { computed, ref } from "vue";

// Components
import Modal from "@/components/modal/modal.vue";
import useTranslate from "@/hooks/useTranslate/useTranslate";
import { useHowYouRateDeviceStore } from "@/stores/howYouRateDevice/howYouRateDevice";
// Store
import { useTIWStore } from "@/stores/tiw/tiw";
import Button from "@/ui/button/button.vue";
import ArrowIcon from "@/ui/icons/arrow.vue";
// Icons
import AwardIcon from "@/ui/icons/award.vue";

const TIWStore = useTIWStore();
const HowYouRateDeviceStore = useHowYouRateDeviceStore();

const showTrustmeKz = computed<boolean>(() =>
    HowYouRateDeviceStore.signingTypes.includes("TRUSTME_KZ"),
);
const showWithoutSms = computed<boolean>(() =>
    HowYouRateDeviceStore.signingTypes.includes("WITHOUT_SMS"),
);
const showScrive = computed<boolean>(() => HowYouRateDeviceStore.signingTypes.includes("SCRIVE"));

const loadingToNext = ref<boolean>(false);

const onClickSigningType = async (singingType: string) => {
    loadingToNext.value = true;
    HowYouRateDeviceStore.setSingingType(singingType);

    TIWStore.switchStep("successfulEvaluation");
    loadingToNext.value = false;
};

const onClickBack = () => {
    TIWStore.switchStep("evaluationResult");
};
</script>

<style lang="scss" src="./chooseSigningType.scss"></style>
